import {use} from 'react';

import {InvoiceVatRateContext} from './InvoiceVatRateContext';

export function useInvoiceVatRatesContext() {
  const context = use(InvoiceVatRateContext);

  if (!context) {
    const error = new Error('useInvoiceVatRate must be used within a InvoiceVatRateProvider');
    error.name = 'ContextError';
    Error.captureStackTrace?.(error, use);
    throw error;
  }

  return context;
}
